function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return _array_like_to_array(arr);
}
function _assert_this_initialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _call_super(_this, derived, args) {
    derived = _get_prototype_of(derived);
    return _possible_constructor_return(_this, _is_native_reflect_construct() ? Reflect.construct(derived, args || [], _get_prototype_of(_this).constructor) : derived.apply(_this, args));
}
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _set_prototype_of(subClass, superClass);
}
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _possible_constructor_return(self, call) {
    if (call && (_type_of(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assert_this_initialized(self);
}
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}
function _to_consumable_array(arr) {
    return _array_without_holes(arr) || _iterable_to_array(arr) || _unsupported_iterable_to_array(arr) || _non_iterable_spread();
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _is_native_reflect_construct() {
    try {
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { PrefetchController } from './base-prefetch-controller';
export var PrefetchQueueController = /*#__PURE__*/ function(PrefetchController) {
    "use strict";
    _inherits(PrefetchQueueController, PrefetchController);
    function PrefetchQueueController(fetcher, config) {
        _class_call_check(this, PrefetchQueueController);
        var _this;
        _this = _call_super(this, PrefetchQueueController, [
            fetcher
        ]), _define_property(_this, "config", void 0), _define_property(_this, "queue", void 0), _define_property(_this, "fetched", void 0), _define_property(_this, "isDeferred", void 0), _define_property(_this, "recursiveTimeout", void 0), _define_property(_this, "recursiveFetch", void 0), _this.config = config, _this.queue = [], _this.fetched = new Set(), _this.isDeferred = false, _this.recursiveFetch = function() {
            var urls = _this.getImmediateFetchList();
            if (urls.length === 0) {
                return;
            }
            var _this1 = _this;
            var fetchPromises = urls.map(/*#__PURE__*/ function() {
                var _ref = _async_to_generator(function(url) {
                    var e;
                    return _ts_generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _state.trys.push([
                                    0,
                                    2,
                                    ,
                                    3
                                ]);
                                return [
                                    4,
                                    _this1.fetcher(url)
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    3,
                                    3
                                ];
                            case 2:
                                e = _state.sent();
                                _this1.logger.warn("Thumbnail prefetch failed for title: ".concat(url));
                                return [
                                    3,
                                    3
                                ];
                            case 3:
                                return [
                                    2
                                ];
                        }
                    });
                });
                return function(url) {
                    return _ref.apply(this, arguments);
                };
            }());
            Promise.all(fetchPromises).catch(function() {}).then(function() {
                _this.recursiveTimeout = setTimeout(function() {
                    return _this.recursiveFetch();
                }, _this.config.delayBetweenFetchesMs);
            });
        };
        return _this;
    }
    _create_class(PrefetchQueueController, [
        {
            key: "handleThumbnailStreamSelected",
            value: function handleThumbnailStreamSelected(thumbnailStream) {
                var sortedThumbnailSegments = _to_consumable_array(thumbnailStream.thumbnailSegments).sort(function(a, b) {
                    return a.startPosition - b.startPosition;
                });
                this.thumbnailStream = _object_spread_props(_object_spread({}, thumbnailStream), {
                    thumbnailSegments: sortedThumbnailSegments
                });
                this.queue = sortedThumbnailSegments.map(function(s) {
                    return s.tileUrl;
                });
                if (!this.isPlayerLoaded) {
                    this.isDeferred = true;
                } else {
                    this.recursiveFetch();
                }
            }
        },
        {
            key: "handleNewSegmentRequested",
            value: function handleNewSegmentRequested(_, index) {
                var _this_thumbnailStream_thumbnailSegments_, _this_thumbnailStream_thumbnailSegments_1;
                var previous = (_this_thumbnailStream_thumbnailSegments_ = this.thumbnailStream.thumbnailSegments[index - 1]) === null || _this_thumbnailStream_thumbnailSegments_ === void 0 ? void 0 : _this_thumbnailStream_thumbnailSegments_.tileUrl;
                var next = (_this_thumbnailStream_thumbnailSegments_1 = this.thumbnailStream.thumbnailSegments[index + 1]) === null || _this_thumbnailStream_thumbnailSegments_1 === void 0 ? void 0 : _this_thumbnailStream_thumbnailSegments_1.tileUrl;
                this.addToQueue(next, previous);
            }
        },
        {
            key: "_handlePlayerLoaded",
            value: function _handlePlayerLoaded() {
                if (this.isDeferred) {
                    this.isDeferred = false;
                    this.recursiveFetch();
                }
            }
        },
        {
            key: "_destroy",
            value: function _destroy() {
                this.queue.length = 0;
                this.fetched.clear();
                clearTimeout(this.recursiveTimeout);
            }
        },
        {
            key: "getImmediateFetchList",
            value: function getImmediateFetchList() {
                var urls = [];
                while(urls.length < this.config.concurrentFetches){
                    var _this_queue;
                    var url = (_this_queue = this.queue) === null || _this_queue === void 0 ? void 0 : _this_queue.shift();
                    if (!url) {
                        break;
                    } else if (this.fetched.has(url)) {
                        continue;
                    }
                    this.fetched.add(url);
                    urls.push(url);
                }
                return urls;
            }
        },
        {
            key: "addToQueue",
            value: function addToQueue() {
                for(var _len = arguments.length, batch = new Array(_len), _key = 0; _key < _len; _key++){
                    batch[_key] = arguments[_key];
                }
                var withoutFalsy = batch.filter(function(url) {
                    return Boolean(url);
                });
                this.queue = _to_consumable_array(withoutFalsy).concat(_to_consumable_array(this.queue));
            }
        }
    ]);
    return PrefetchQueueController;
}(PrefetchController);

//# sourceMappingURL=prefetch-queue-controller.js.map